<template lang="pug">
  MainWrapper(:inner="!onError" :main="!!onError" :content="true")
    ArticleContent(v-show="!onLoad" v-if="!onError")
    E404(v-if="onError")
    //- RelatedArticles
</template>

<script>
import { ContentModuleMapper } from '@/store/modules/content';
import { MenuModuleMapper } from '@/store/modules/menu';
import ArticleContent from '@/components/common/article.vue';
import MainWrapper from '@/components/common/main.vue';
import RelatedArticles from '@/components/content/relatedArticles/relatedArticles.vue';
import E404 from '@/components/common/E404.vue';
import { getLocale } from '@/i18n';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { RootMapper } from '@/store';

export default {
  name: 'Article',
  layout: 'default',
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.data.header,
        },
      ],
      htmlAttrs: {
        lang: this.$i18n.locale,
        amp: true,
      },
    };
  },
  computed: {
    ...ContentModuleMapper.mapState(['data', 'onLoad', 'onError', 'redirectUrl']),
    ...ConstantsModuleMapper.mapGetters(['Page404']),
    ...RootMapper.mapState(['onCriticalError']),
    title() {
      if (this.data.header) {
        try {
          const doc = new DOMParser().parseFromString(this.data.header, 'text/html');
          return doc.documentElement.textContent;
        } catch (e) {
          console.error(e);
          return this.data.header;
        }
      }
      return this.$t(`${this.Page404.title}`, this.$i18n.locale);
    },
  },
  components: {
    MainWrapper,
    ArticleContent,
    E404,
    RelatedArticles,
  },
  async beforeRouteUpdate(to, from, next) {
    if (!this.onCriticalError) {
      let res;
      try {
        res = await this.preloadPage({
          locale: getLocale(),
          url: to.path,
        });
      } catch (e) {
        return next(false);
      }
      if (!res && this.redirectUrl.length) {
        return next({
          params: {
            lang: getLocale(),
          },
          path: this.redirectUrl,
        });
      }
      this.scrollInto();
      if (res) {
        return next();
      }
    }
    return next(false);
  },
  mounted() {
    this.scrollInto();
  },
  methods: {
    scrollInto() {
      if (this.$route.hash) {
        this.$nextTick(() => {
          const id = this.$route.hash.substr(1);
          const element = document.querySelector(`#${id}, [name="${id}"]`);
          if (element) {
            try {
              element.scrollIntoView();
              // eslint-disable-next-line no-empty
            } catch (e) {
            }
          }
        });
      }
    },
    ...MenuModuleMapper.mapMutations({
      setActive: 'setActive',
    }),
    ...ContentModuleMapper.mapActions({
      preloadPage: 'preloadPage',
    }),
  },
};
</script>

<style lang="scss" scoped>
  .preloader {
    margin-top: 82px;
    @media all and (min-width: 1280px) {
      margin-top: 68px;
    }
    @media all and (min-width: 1920px) {
      margin-top: 90px;
    }
  }
  .el-1 {
    @media all and (max-width: 1279px) {
      height: 16px!important;
      margin-bottom: 8px;
    }
    @media all and (min-width: 1280px) {
      transform: translateX(calc(-100% - 4px));
      margin-bottom: -20px;
    }
  }
  .el-2 {
    margin-bottom: 47px;
    width: 100%!important;
    max-width: 550px;

    @media all and (max-width: 1268px) {
      height: 33px!important;
      margin-bottom: 30px;
      max-width: 270px;
    }
  }
  .el-3 {
    margin-bottom: 26px;
    width: 100%!important;
    @media all and (max-width: 767px) {
      height: 24px!important;
      margin-bottom: 18px;
    }
  }
  .el-4 {
    margin-bottom: 26px;
    width: 100%!important;
    @media all and (max-width: 767px) {
      height: 24px!important;
      margin-bottom: 18px;
    }
  }
  .el-5 {
    margin-bottom: 26px;
    width: 100%!important;
    @media all and (max-width: 767px) {
      height: 24px!important;
      margin-bottom: 18px;
    }
  }
  .el-6 {
    margin-left: auto;
  }
</style>
